export const GETRMDETAILS = "GETRMDETAILS_GROUPS";
export const GETRMDETAILS_ERROR = "GETRMDETAILS_ERROR";
export const GETRMDETAILS_HIDE_ERROR = "GETRMDETAILS_HIDE_ERROR";
export const GETRMDETAILS_START_LOADER = "GETRMDETAILS_START_LOADER";
export const GETRMDETAILS_STOP_LOADER = "GETRMDETAILS_STOP_LOADER";
